import { forwardRef, ListItem as ChakraListItem, ListItemProps as ChakraListItemProps } from '@chakra-ui/react';
import Box, { BoxProps } from '../Box/Box';
import Icon, { IconProps, TypeIconName } from '../Icon/Icon';

export interface ListItemProps extends ChakraListItemProps {
  iconColor?: BoxProps['color'];
  iconName?: TypeIconName;
  iconSize?: IconProps['size'];
}

/**
 * ListItem is the valid children of List. It renders a <li> element by default.
 */
const ListItem = forwardRef<ListItemProps, 'li'>((props, ref) => {
  const { children, iconColor, iconName, iconSize, ...rest } = props;
  let iconVerticalAlign = 'middle';
  if (iconSize === '16') {
    iconVerticalAlign = '-3px';
  }
  if (iconSize === '24') {
    iconVerticalAlign = '-6px';
  }
  if (iconSize === '32') {
    iconVerticalAlign = '-11px';
  }

  return (
    <ChakraListItem {...rest} ref={ref} listStylePosition="outside">
      <Box display="flex" alignItems="flex-start">
        {!!iconName && (
          <Icon
            flexShrink={0}
            name={iconName}
            height="100%"
            color={iconColor}
            marginEnd="6"
            size={iconSize}
            verticalAlign={iconVerticalAlign}
          />
        )}
        <Box flexGrow={1}>{children}</Box>
      </Box>
    </ChakraListItem>
  );
});

export default ListItem;
